import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import VaRadioField from 'platform/forms-system/src/js/web-component-fields/VaRadioField';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { RESERVE_COMPONENT_LABELS } from '../../constants';

const { serviceInformation } = fullSchema.properties;

export default {
  uiSchema: {
    ...titleUI('Federal orders'),
    serviceInformation: {
      reservesNationalGuardService: {
        component: {
          'ui:title': 'Which component have you served in most recently?',
          'ui:webComponentField': VaRadioField,
          'ui:errorMessages': {
            required: 'You must provide a response',
          },
          'ui:options': {
            labels: RESERVE_COMPONENT_LABELS,
          },
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['reservesNationalGuardService'],
        properties: {
          reservesNationalGuardService: {
            type: 'object',
            required: ['component'],
            properties: {
              component:
                serviceInformation.properties.reservesNationalGuardService
                  .properties.component,
            },
          },
        },
      },
    },
  },
};
